// src/redux/actionTypes.js
export const REGISTER_REQUEST = "REGISTER_REQUEST";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const DASHBOARD_REQUEST = "DASHBOARD_REQUEST";
export const DASHBOARD_SUCCESS = "DASHBOARD_SUCCESS";
export const DASHBOARD_FAIL = "DASHBOARD_FAIL";
export const CREATE_ORDER_REQUEST = "CREATE_ORDER_REQUEST";
export const CREATE_ORDER_SUCCESS = "CREATE_ORDER_SUCCESS";
export const CREATE_ORDER_FAIL = "CREATE_ORDER_FAIL";
export const ORDER_LIST_REQUEST = "ORDER_LIST_REQUEST";
export const ORDER_LIST_SUCCESS = "ORDER_LIST_SUCCESS";
export const ORDER_LIST_FAIL = "ORDER_LIST_FAIL";
export const ORDER_UPDATE_REQUEST = "ORDER_UPDATE_REQUEST";
export const ORDER_UPDATE_SUCCESS = "ORDER_UPDATE_SUCCESS";
export const ORDER_UPDATE_FAIL = "ORDER_UPDATE_FAIL";
export const QR_ACTIVATION_REQUEST = "QR_ACTIVATION_REQUEST";
export const QR_ACTIVATION_SUCCESS = "QR_ACTIVATION_SUCCESS";
export const QR_ACTIVATION_FAIL = "QR_ACTIVATION_FAIL";
export const ORDER_QR_ACTIVATED = "ORDER_QR_ACTIVATED";
export const QR_DEACTIVATION_REQUEST = "QR_DEACTIVATION_REQUEST";
export const QR_DEACTIVATION_SUCCESS = "QR_DEACTIVATION_SUCCESS";
export const QR_DEACTIVATION_FAIL = "QR_DEACTIVATION_FAIL";
export const ORDER_STATS_REQUEST = "ORDER_STATS_REQUEST";
export const ORDER_STATS_SUCCESS = "ORDER_STATS_SUCCESS";
export const ORDER_STATS_FAIL = "ORDER_STATS_FAIL";
export const APPROVE_ORDER_REQUEST = "APPROVE_ORDER_REQUEST";
export const APPROVE_ORDER_SUCCESS = "APPROVE_ORDER_SUCCESS";
export const APPROVE_ORDER_FAIL = "APPROVE_ORDER_FAIL";
export const REDEEM_QR_REQUEST = "REDEEM_QR_REQUEST";
export const REDEEM_QR_SUCCESS = "REDEEM_QR_SUCCESS";
export const REDEEM_QR_FAIL = "REDEEM_QR_FAIL";
export const QR_STATUS_REQUEST = "QR_STATUS_REQUEST";
export const QR_STATUS_SUCCESS = "QR_STATUS_SUCCESS";
export const QR_STATUS_FAIL = "QR_STATUS_FAIL";
export const ORDER_DOWNLOAD_REQUEST = "ORDER_DOWNLOAD_REQUEST";
export const ORDER_DOWNLOAD_SUCCESS = "ORDER_DOWNLOAD_SUCCESS";
export const ORDER_DOWNLOAD_FAIL = "ORDER_DOWNLOAD_FAIL";
export const UPDATE_ORDER_DOWNLOAD_STATUS_REQUEST = "UPDATE_ORDER_DOWNLOAD_STATUS_REQUEST";
export const UPDATE_ORDER_DOWNLOAD_STATUS_SUCCESS = "UPDATE_ORDER_DOWNLOAD_STATUS_SUCCESS";
export const UPDATE_ORDER_DOWNLOAD_STATUS_FAIL = "UPDATE_ORDER_DOWNLOAD_STATUS_FAIL";
export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAIL = "LOGOUT_FAIL";
export const PROCESS_ORDER_REQUEST = "PROCESS_ORDER_REQUEST";
export const PROCESS_ORDER_SUCCESS = "PROCESS_ORDER_SUCCESS";
export const PROCESS_ORDER_FAIL = "PROCESS_ORDER_FAIL";
// src/actionTypes.js
export const PAYMENT_LIST_REQUEST = "PAYMENT_LIST_REQUEST";
export const PAYMENT_LIST_SUCCESS = "PAYMENT_LIST_SUCCESS";
export const PAYMENT_LIST_FAIL = "PAYMENT_LIST_FAIL";

export const PAYMENT_REQUEST = "PAYMENT_REQUEST";
export const PAYMENT_SUCCESS = "PAYMENT_SUCCESS";
export const PAYMENT_FAIL = "PAYMENT_FAIL";
export const STATE_CITY_REQUEST = "STATE_CITY_REQUEST";
export const STATE_CITY_SUCCESS = "STATE_CITY_SUCCESS";
export const STATE_CITY_FAIL = "STATE_CITY_FAIL";

export const CUSTOMER_LIST_REQUEST = "CUSTOMER_LIST_REQUEST";
export const CUSTOMER_LIST_SUCCESS = "CUSTOMER_LIST_SUCCESS";
export const CUSTOMER_LIST_FAIL = "CUSTOMER_LIST_FAIL";
// src/redux/constants/dealerConstants.js
export const FETCH_DEALERS_REQUEST = "FETCH_DEALERS_REQUEST";
export const FETCH_DEALERS_SUCCESS = "FETCH_DEALERS_SUCCESS";
export const FETCH_DEALERS_FAIL = "FETCH_DEALERS_FAIL";

export const UPDATE_USER_REQUEST = "UPDATE_USER_REQUEST";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAIL = "UPDATE_USER_FAIL";
export const UPDATE_USER_RESET = "UPDATE_USER_RESET";

export const FETCH_ADMINDET_REQUEST = "FETCH_ADMINDET_REQUEST";
export const FETCH_ADMINDET_SUCCESS = "FETCH_ADMINDET_SUCCESS";
export const FETCH_ADMINDET_FAIL = "FETCH_ADMINDET_FAIL";
export const UPDATE_ADMINDET_REQUEST = "UPDATE_ADMINDET_REQUEST";
export const UPDATE_ADMINDET_SUCCESS = "UPDATE_ADMINDET_SUCCESS";
export const UPDATE_ADMINDET_FAIL = "UPDATE_ADMINDET_FAIL";
// src/features/dealer/dealerTypes.js

export const UPDATE_DEALER_STATUS_REQUEST = "UPDATE_DEALER_STATUS_REQUEST";
export const UPDATE_DEALER_STATUS_SUCCESS = "UPDATE_DEALER_STATUS_SUCCESS";
export const UPDATE_DEALER_STATUS_FAIL = "UPDATE_DEALER_STATUS_FAIL";

export const SHARE_CREDENTIALS_REQUEST = "SHARE_CREDENTIALS_REQUEST";
export const SHARE_CREDENTIALS_SUCCESS = "SHARE_CREDENTIALS_SUCCESS";
export const SHARE_CREDENTIALS_FAIL = "SHARE_CREDENTIALS_FAIL";

export const FETCH_CLIENT_REPORT_REQUEST = "FETCH_CLIENT_REPORT_REQUEST";
export const FETCH_CLIENT_REPORT_SUCCESS = "FETCH_CLIENT_REPORT_SUCCESS";
export const FETCH_CLIENT_REPORT_FAILURE = "FETCH_CLIENT_REPORT_FAILURE";

export const QRSTATUS_DATE_REQUEST = "QRSTATUS_DATE_REQUEST";
export const QRSTATUS_DATE_SUCCESS = "QRSTATUS_DATE_SUCCESS";
export const QRSTATUS_DATE_FAILURE = "QRSTATUS_DATE_FAILURE";
export const CREATE_SALESMAN_REQUEST = "CREATE_SALESMAN_REQUEST";
export const CREATE_SALESMAN_SUCCESS = "CREATE_SALESMAN_SUCCESS";
export const CREATE_SALESMAN_FAIL = "CREATE_SALESMAN_FAIL";

export const FETCH_SALESMAN_LIST_REQUEST = "FETCH_SALESMAN_LIST_REQUEST";
export const FETCH_SALESMAN_LIST_SUCCESS = "FETCH_SALESMAN_LIST_SUCCESS";
export const FETCH_SALESMAN_LIST_FAIL = "FETCH_SALESMAN_LIST_FAIL";

export const CREATE_GIFT_CREATE_REQUEST = "CREATE_GIFT_CREATE_REQUEST";
export const CREATE_GIFT_CREATE_SUCCESS = "CREATE_GIFT_CREATE_SUCCESS";
export const CREATE_GIFT_CREATE_FAIL = "CREATE_GIFT_CREATE_FAIL";

export const FETCH_GIFT_LIST_REQUEST = "FETCH_GIFT_LIST_REQUEST";
export const FETCH_GIFT_LIST_SUCCESS = "FETCH_GIFT_LIST_SUCCESS";
export const FETCH_GIFT_LIST_FAIL = "FETCH_GIFT_LIST_FAIL";

export const CREATE_SALESMAN_CUSTOMER_REQUEST =
  "CREATE_SALESMAN_CUSTOMER_REQUEST";
export const CREATE_SALESMAN_CUSTOMER_SUCCESS =
  "CREATE_SALESMAN_CUSTOMER_SUCCESS";
export const CREATE_SALESMAN_CUSTOMER_FAIL = "CREATE_SALESMAN_CUSTOMER_FAIL";

export const FETCH_SALESMAN_CUSTOMER_LIST_REQUEST =
  "FETCH_SALESMAN_CUSTOMER_LIST_REQUEST";
export const FETCH_SALESMAN_CUSTOMER_LIST_SUCCESS =
  "FETCH_SALESMAN_CUSTOMER_LIST_SUCCESS";
export const FETCH_SALESMAN_CUSTOMER_LIST_FAIL =
  "FETCH_SALESMAN_CUSTOMER_LIST_FAIL";

export const VALIDATE_QR_REQUEST = "VALIDATE_QR_REQUEST";
export const VALIDATE_QR_SUCCESS = "VALIDATE_QR_SUCCESS";
export const VALIDATE_QR_FAIL = "VALIDATE_QR_FAIL";

export const FETCH_REDEMTION_CUSTOMER_REQUEST =
  "FETCH_REDEMTION_CUSTOMER_REQUEST";
export const FETCH_REDEMTION_CUSTOMER_SUCCESS =
  "FETCH_REDEMTION_CUSTOMER_SUCCESS";
export const FETCH_REDEMTION_CUSTOMER_FAIL = "FETCH_REDEMTION_CUSTOMER_FAIL";

export const GIFT_REDEEM_QR_REQUEST = "GIFT_REDEEM_QR_REQUEST";
export const GIFT_REDEEM_QR_SUCCESS = "GIFT_REDEEM_QR_SUCCESS";
export const GIFT_REDEEM_QR_FAIL = "GIFT_REDEEM_QR_FAIL";

export const CUSTOMER_TYPE_REQUEST = "CUSTOMER_TYPE_REQUEST";
export const CUSTOMER_TYPE_SUCCESS = "CUSTOMER_TYPE_SUCCESS";
export const CUSTOMER_TYPE_FAIL = "CUSTOMER_TYPE_FAIL";

export const CREATE_GIFT_MASTER_CREATE_REQUEST =
  "CREATE_GIFT_MASTER_CREATE_REQUEST";
export const CREATE_GIFT_MASTER_CREATE_SUCCESS =
  "CREATE_GIFT_MASTER_CREATE_SUCCESS";
export const CREATE_GIFT_MASTER_CREATE_FAIL = "CREATE_GIFT_MASTER_CREATE_FAIL";

export const FETCH_GIFT_MASTER_REQUEST = "FETCH_GIFT_MASTER_REQUEST";
export const FETCH_GIFT_MASTER_SUCCESS = "FETCH_GIFT_MASTER_SUCCESS";
export const FETCH_GIFT_MASTER_FAIL = "FETCH_GIFT_MASTER_FAIL";

export const FETCH_OFFER_SCHEME_REQUEST = "FETCH_OFFER_SCHEME_REQUEST";
export const FETCH_OFFER_SCHEME_SUCCESS = "FETCH_OFFER_SCHEME_SUCCESS";
export const FETCH_OFFER_SCHEME_FAIL = "FETCH_OFFER_SCHEME_FAIL";

export const FETCH_GIFTS_BY_SCHEME_REQUEST = "FETCH_GIFTS_BY_SCHEME_REQUEST";
export const FETCH_GIFTS_BY_SCHEME_SUCCESS = "FETCH_GIFTS_BY_SCHEME_SUCCESS";
export const FETCH_GIFTS_BY_SCHEME_FAIL = "FETCH_GIFTS_BY_SCHEME_FAIL";

export const UPDATE_GIFT_MASTER_REQUEST = "UPDATE_GIFT_MASTER_REQUEST";
export const UPDATE_GIFT_MASTER_SUCCESS = "UPDATE_GIFT_MASTER_SUCCESS";
export const UPDATE_GIFT_MASTER_FAILED = "UPDATE_GIFT_MASTER_FAILED";

export const ADD_GIFT_TO_SCHEME_REQUEST = "ADD_GIFT_TO_SCHEME_REQUEST";
export const ADD_GIFT_TO_SCHEME_SUCCESS = "ADD_GIFT_TO_SCHEME_SUCCESS";
export const ADD_GIFT_TO_SCHEME_FAIL = "ADD_GIFT_TO_SCHEME_FAIL";

export const FETCH_SALESMAN_DASHBOARD_DATA_REQUEST ="FETCH_SALESMAN_DASHBOARD_DATA_REQUEST";
export const FETCH_SALESMAN_DASHBOARD_DATA_SUCCESS="FETCH_SALESMAN_DASHBOARD_DATA_SUCCESS";
export const FETCH_SALESMAN_DASHBOARD_DATA_FAIL ="FETCH_SALESMAN_DASHBOARD_DATA_FAIL";

export const FETCH_SALESMAN_CONSOLIDATED_REPORT_REQUEST = "FETCH_SALESMAN_CONSOLIDATED_REPORT_REQUEST";
export const FETCH_SALESMAN_CONSOLIDATED_REPORT_SUCCESS = "FETCH_SALESMAN_CONSOLIDATED_REPORT_SUCCESS";
export const FETCH_SALESMAN_CONSOLIDATED_REPORT_FAIL = "FETCH_SALESMAN_CONSOLIDATED_REPORT_FAIL";

export const FETCH_CUSTOMER_CONSOLIDATED_REPORT_REQUEST = "FETCH_CUSTOMER_CONSOLIDATED_REPORT_REQUEST";
export const FETCH_CUSTOMER_CONSOLIDATED_REPORT_SUCCESS = "FETCH_CUSTOMER_CONSOLIDATED_REPORT_SUCCESS";
export const FETCH_CUSTOMER_CONSOLIDATED_REPORT_FAIL = "FETCH_CUSTOMER_CONSOLIDATED_REPORT_FAIL";
export const UPDATE_ORDER_REQUEST = "UPDATE_ORDER_REQUEST";
export const UPDATE_ORDER_SUCCESS = "UPDATE_ORDER_SUCCESS";
export const UPDATE_ORDER_FAIL = "UPDATE_ORDER_FAIL";

export const CREATE_BANNER_REQUEST = "CREATE_BANNER_REQUEST";
export const CREATE_BANNER_SUCCESS = "CREATE_BANNER_SUCCESS";
export const CREATE_BANNER_FAIL = "CREATE_BANNER_FAIL";

export const GET_BANNERS_REQUEST = "GET_BANNERS_REQUEST";
export const GET_BANNERS_SUCCESS = "GET_BANNERS_SUCCESS";
export const GET_BANNERS_FAIL = "GET_BANNERS_FAIL";

export const DELETE_BANNER_REQUEST = "DELETE_BANNER_REQUEST";
export const DELETE_BANNER_SUCCESS = "DELETE_BANNER_SUCCESS";
export const DELETE_BANNER_FAIL = "DELETE_BANNER_FAIL";

export const CREATE_QR_DESIGN_REQUEST = "CREATE_QR_DESIGN_REQUEST";
export const CREATE_QR_DESIGN_SUCCESS = "CREATE_QR_DESIGN_SUCCESS";
export const CREATE_QR_DESIGN_FAIL = "CREATE_QR_DESIGN_FAIL";

export const GET_QR_DESIGNS_REQUEST = "GET_QR_DESIGNS_REQUEST";
export const GET_QR_DESIGNS_SUCCESS = "GET_QR_DESIGNS_SUCCESS";
export const GET_QR_DESIGNS_FAIL = "GET_QR_DESIGNS_FAIL";

export const UPDATE_PASSWORD_REQUEST = "UPDATE_PASSWORD_REQUEST";
export const UPDATE_PASSWORD_SUCCESS = "UPDATE_PASSWORD_SUCCESS";
export const UPDATE_PASSWORD_FAIL = "UPDATE_PASSWORD_FAIL";
export const GET_DEALER_ACCESS_REQUEST = "GET_DEALER_ACCESS_REQUEST";
export const GET_DEALER_ACCESS_SUCCESS = "GET_DEALER_ACCESS_SUCCESS";
export const GET_DEALER_ACCESS_FAIL = "GET_DEALER_ACCESS_FAIL";
export const UPDATE_DEALER_ACCESS_REQUEST = "UPDATE_DEALER_ACCESS_REQUEST";
export const UPDATE_DEALER_ACCESS_SUCCESS = "UPDATE_DEALER_ACCESS_SUCCESS";
export const UPDATE_DEALER_ACCESS_FAIL    = "UPDATE_DEALER_ACCESS_FAIL";
export const CREATE_SLOGAN_REQUEST ="CREATE_SLOGAN_REQUEST";
export const CREATE_SLOGAN_SUCCESS = "CREATE_SLOGAN_SUCCESS";
export const CREATE_SLOGAN_FAIL = "CREATE_SLOGAN_FAIL";
export const GET_SLOGAN_REQUEST = "GET_SLOGAN_REQUEST";
export const GET_SLOGAN_SUCCESS = "GET_SLOGAN_SUCCESS";
export const GET_SLOGAN_FAIL ="GET_SLOGAN_FAIL";
export const FETCH_OTP_REQUEST = "FETCH_OTP_REQUEST";
export const FETCH_OTP_SUCCESS = "FETCH_OTP_SUCCESS";
export const FETCH_OTP_FAIL = "FETCH_OTP_FAIL";

export const FETCH_CUSTOMER_DETAILS_REQUEST = "FETCH_CUSTOMER_DETAILS_REQUEST";
export const FETCH_CUSTOMER_DETAILS_SUCCESS = "FETCH_CUSTOMER_DETAILS_SUCCESS";
export const FETCH_CUSTOMER_DETAILS_FAIL = "FETCH_CUSTOMER_DETAILS_FAIL";

export const REDEEM_PROMOTIONAL_QR_REQUEST = "REDEEM_PROMOTIONAL_QR_REQUEST";
export const REDEEM_PROMOTIONAL_QR_SUCCESS = "REDEEM_PROMOTIONAL_QR_SUCCESS";
export const REDEEM_PROMOTIONAL_QR_FAIL    = "REDEEM_PROMOTIONAL_QR_FAIL";

export const ORDER_QR_STATUS_SUCCESS = "ORDER_QR_STATUS_SUCCESS";
export const ORDER_QR_STATUS_FAIL = "ORDER_QR_STATUS_FAIL";
export const ORDER_QR_STATUS_REQUEST = "ORDER_QR_STATUS_REQUEST";

export const SALESMAN_QR_CODE_REEDEM_REPORT_COUNT_SUCCESS  = "SALESMAN_QR_CODE_REEDEM_REPORT_COUNT_SUCCESS";
export const SALESMAN_QR_CODE_REEDEM_REPORT_COUNT_FAIL  = "SALESMAN_QR_CODE_REEDEM_REPORT_COUNT_FAIL";
export const SALESMAN_QR_CODE_REEDEM_REPORT_COUNT_REQUEST  = "SALESMAN_QR_CODE_REEDEM_REPORT_COUNT_REQUEST";
// export const REDEEM_QR_REQUEST = "REDEEM_QR_REQUEST";
// export const REDEEM_QR_SUCCESS = "REDEEM_QR_SUCCESS";
// export const REDEEM_QR_FAIL = "REDEEM_QR_FAIL";

export const KARNATAKA_CITIES_REQUEST = "KARNATAKA_CITIES_REQUEST";
export const KARNATAKA_CITIES_SUCCESS = "KARNATAKA_CITIES_SUCCESS";
export const KARNATAKA_CITIES_FAIL = "KARNATAKA_CITIES_FAIL";
export const CUSTOMER_REDEMPTION_SUMMARY_REQUEST = "CUSTOMER_REDEMPTION_SUMMARY_REQUEST";
export const CUSTOMER_REDEMPTION_SUMMARY_SUCCESS = "CUSTOMER_REDEMPTION_SUMMARY_SUCCESS";
export const CUSTOMER_REDEMPTION_SUMMARY_FAIL = "CUSTOMER_REDEMPTION_SUMMARY_FAIL";